
import React from 'react';
import { cn } from '@/lib/utils';
import { AlertCircle, AlertTriangle, Info } from 'lucide-react';

interface AlertCardProps {
  type: 'critical' | 'warning' | 'info';
  title: string;
  message: string;
  time: string;
  className?: string;
}

const AlertCard: React.FC<AlertCardProps> = ({
  type,
  title,
  message,
  time,
  className,
}) => {
  return (
    <div
      className={cn(
        "rounded-lg p-4 border-l-4 flex items-start gap-3",
        type === 'critical' && "bg-red-500/10 border-red-500",
        type === 'warning' && "bg-amber-500/10 border-amber-500",
        type === 'info' && "bg-blue-500/10 border-blue-500",
        "card-auto-height",
        className
      )}
    >
      <div className="mt-0.5 flex-shrink-0">
        {type === 'critical' && <AlertCircle className="h-5 w-5 text-red-500" />}
        {type === 'warning' && <AlertTriangle className="h-5 w-5 text-amber-500" />}
        {type === 'info' && <Info className="h-5 w-5 text-blue-500" />}
      </div>
      
      <div className="flex-1 overflow-hidden">
        <h4 className="text-sm font-semibold overflow-wrap-anywhere">{title}</h4>
        <p className="text-sm text-muted-foreground overflow-wrap-anywhere">{message}</p>
        <p className="text-xs text-muted-foreground/70 mt-1">{time}</p>
      </div>
    </div>
  );
};

export default AlertCard;
